import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  appid: process.env.VUE_APP_APPID,
	  projectUrl: process.env.VUE_APP_DOMAIN + '/' + process.env.VUE_APP_APPID + '/client_center/index.html#',  //当前项目地址
	  keeperUrl: process.env.VUE_APP_DOMAIN + '/' + process.env.VUE_APP_APPID + '/policy_keeper/index.html#',  //保管管家地址
	  ucUrl: process.env.VUE_APP_UC + '/view/myProfile/myProfile.html',  //UC地址
	  loading: false,  //loading动画  白色背景
	  onlyLoading: false,  //loading动画  透明背景
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
